import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-text-medium',
    templateUrl: './text-medium.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextMediumComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
